
// http://121.36.13.81:4067/geoserver/satelliteview/wms?satelliteview:1540952798657-Countries

/* global  Cesium */

function getTerrainLayer (layerinfo) {
  const oURL = layerinfo.url
  const terrainProvider = new Cesium.CesiumTerrainProvider({
    url: oURL
  })
  return terrainProvider
}

// terrain 类型 与其他不同
function addTerrainLayer (params, viewer) {
  const terrainProvider = getTerrainLayer(params)
  // terrain 设置与其他不同
  viewer.scene.terrainProvider = terrainProvider
}

function removeTerrainLayer (viewer) {
  viewer.scene.terrainProvider = null
}

export { addTerrainLayer, removeTerrainLayer }
